import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

// third party modules
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MomentModule} from 'ngx-moment';
import {FileSaverModule} from 'ngx-filesaver';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {ResponsiveModule} from 'ngx-responsive';
import {ToastrModule} from 'ngx-toastr';
import {NgxUiLoaderModule, NgxUiLoaderHttpModule} from 'ngx-ui-loader';

// app modules
import {SharedModule} from '../shared/shared.module';
import {SitePagesModule} from '../sitepages/sitepages.module';

// Routes
import {APP_PAGES_ROUTES} from './apppages.routes';

// Pipes
import {DomseguroPipe} from "../pipes/domseguro.pipe";

// Components
import { ViewfineComponent } from './viewfine/viewfine.component';
import { PayerrorComponent } from './payerror/payerror.component';
import { ProcessingpayComponent } from './processingpay/processingpay.component';
import { ViewpdfComponent } from './viewpdf/viewpdf.component';
import { IdentificationComponent } from './identification/identification.component';
import { SharingComponent } from './sharing/sharing.component';
import { RejectComponent } from './reject/reject.component';
import { PaymentComponent } from './payment/payment.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { PendingComponent } from './pending/pending.component';
import {DataTablesModule} from 'angular-datatables';
import {FinegroupComponent} from './finegroup/finegroup.component';
import {FlexLayoutModule} from '@angular/flex-layout';

/**
 * AppPages Module
 */
@NgModule({
    declarations: [
        ViewfineComponent,
        DomseguroPipe,
        PayerrorComponent,
        ProcessingpayComponent,
        ViewpdfComponent,
        IdentificationComponent,
        SharingComponent,
        RejectComponent,
        PaymentComponent,
        ThankyouComponent,
        PendingComponent,
        FinegroupComponent
    ],
    exports: [],
    imports: [
        SitePagesModule,
        SharedModule,
        APP_PAGES_ROUTES,
        FormsModule,
        TranslateModule,
        CommonModule,
        NgbModule,
        MomentModule,
        FileSaverModule,
        NgxUiLoaderModule,
        NgxUiLoaderHttpModule,
        NgxExtendedPdfViewerModule,
        ResponsiveModule.forRoot(),
        ToastrModule.forRoot({
            preventDuplicates: true,
            disableTimeOut: false,
            closeButton: true,
            progressBar: true
        }),
        ReactiveFormsModule,
        DataTablesModule,
        FlexLayoutModule
    ]
})
export class AppPagesModule {
}
